import outlook from "../assets/logo outlook.png";
import phone from "../assets/iphone.png";
import Loc from "../../Loc/Loc";

interface AuthentificationChoiceProps {
    setEnterMail: React.Dispatch<React.SetStateAction<boolean>>;
    setStateSendingSMS: React.Dispatch<React.SetStateAction<boolean>>;
    setWaitingForCode: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function AuthentificationChoice(props: AuthentificationChoiceProps) {
    const EnterMail = () => {
        props.setEnterMail(true);
    }
    const SendSMS = () => {
        props.setStateSendingSMS(true);
        // requête envoi sms
        setTimeout(() => {
            props.setStateSendingSMS(false);
            props.setWaitingForCode(true);
        }, 3000);
    }

    return (
        <div>
            <button type="button" className="btn btn-primary btn-lg" onClick={EnterMail} style={{ margin: '20px' }}>
                <div style={{ fontSize: '1.5rem' }}>{Loc.trad().AuthentificationChoiceMail}</div>
                <img src={outlook} alt="logo dossier" style={{ height: '100px', width: '180px' }}></img>
            </button>
            <button type="button" className="btn btn-secondary btn-lg" onClick={SendSMS} style={{ margin: '20px' }} disabled>
                <div style={{ fontSize: '1.5rem' }}>{Loc.trad().AuthentificationChoiceSMS}</div>
                <img src={phone} alt="logo dossier" style={{ height: '100px', width: '100px' }}></img>
            </button>
        </div>
    )
}